module.exports = __webpack_public_path__ + "static/media/sopt21kz.6868d495.pdf";